import { render, staticRenderFns } from "./AlarmDetailsProgression.vue?vue&type=template&id=73c5f5f6&"
import script from "./AlarmDetailsProgression.vue?vue&type=script&lang=ts&"
export * from "./AlarmDetailsProgression.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
